import { useState, useEffect} from "react";

const FontLink = () => {
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Syne:wght@400;500;600;700;800&display=swap";
    document.head.appendChild(l);
  }, []);
  return null;
};

const IC = {
  Code:    () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>,
  Health:  () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  Grid:    () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  Brain:   () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3z"/></svg>,
  Chart:   () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>,
  Globe:   () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  Eye:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/></svg>,
  Zap:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>,
  Monitor: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  Shield:  () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Pulse:   () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  CPU:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>,
  Arrow:   () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>,
  ArrowR:  () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  Mail:    () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  Phone:   () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.59 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/></svg>,
  MapPin:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  Check:   () => <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  Quote:   () => <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/></svg>,
  AI:      () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="2"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3"/><circle cx="12" cy="12" r="6" strokeDasharray="2 3"/></svg>,
  IVF:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3"/></svg>,
  HMS:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  HR:      () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>,
  ERP:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/></svg>,
  Web:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  CRM:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
};

const CSS = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  :root{
    --paper:#f2efe8;
    --paper2:#ebe7de;
    --paper3:#e4e0d6;
    --ink:#18160f;
    --ink2:#3a3830;
    --ink3:#7a776e;
    --ink4:#a8a59c;
    --rule:#ccc9be;
    --rule2:#b8b5aa;
    --red:#c0392b;
    --red-pale:#f9eeec;
    --surface:#ffffff;
    --S:'Instrument Serif',serif;
    --B:'Syne',sans-serif;
  }
  html{scroll-behavior:smooth}
  body{background:var(--paper);color:var(--ink);font-family:var(--B);overflow-x:hidden;-webkit-font-smoothing:antialiased}
  ::selection{background:var(--ink);color:var(--paper)}
  ::-webkit-scrollbar{width:3px}::-webkit-scrollbar-track{background:var(--paper2)}::-webkit-scrollbar-thumb{background:var(--ink3)}
  a{color:inherit;text-decoration:none}

  /* NAV */
  .nav{position:fixed;top:0;inset-inline:0;z-index:300;height:64px;display:flex;align-items:center;justify-content:space-between;padding:0 5%;transition:background .35s,border-color .35s;border-bottom:1px solid transparent}
  .nav.on{background:rgba(242,239,232,.96);backdrop-filter:blur(16px);border-color:var(--rule)}
  .logo{font-family:var(--S);font-size:1.55rem;color:var(--ink);letter-spacing:.01em;font-style:italic}
  .logo b{font-style:normal;font-family:var(--B);font-weight:800;font-size:1.1rem;letter-spacing:.08em}
  .nav-links{display:flex;gap:2rem;list-style:none}
  .nav-links a{font-size:.75rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);transition:color .2s}
  .nav-links a:hover{color:var(--ink)}
  .nav-cta{display:flex;align-items:center;gap:8px;padding:.55rem 1.3rem;border-radius:2px;background:var(--ink);color:var(--paper);font-size:.75rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;border:none;font-family:var(--B);transition:all .2s}
  .nav-cta:hover{background:var(--ink2)}

  /* HERO */
  .hero{min-height:100vh;background:var(--paper);display:grid;grid-template-rows:1fr auto;padding-top:64px;position:relative;overflow:hidden}
  .hero-lines{position:absolute;inset:0;pointer-events:none}
  .hero-col{position:absolute;top:0;bottom:0;width:1px;background:var(--rule);opacity:.5}
  .hero-body{display:grid;grid-template-columns:1fr 1fr;min-height:calc(100vh - 64px - 48px);border-bottom:1px solid var(--rule)}
  .hero-left{padding:6% 5% 5% 5%;display:flex;flex-direction:column;justify-content:space-between;border-right:1px solid var(--rule)}
  .hero-right{padding:6% 5% 5% 5%;display:flex;flex-direction:column;justify-content:flex-end}
  .eyebrow{display:inline-flex;align-items:center;gap:10px;font-size:.68rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--ink3);margin-bottom:3rem;animation:fU .7s ease both}
  .ey-dot{width:5px;height:5px;border-radius:50%;background:var(--red);flex-shrink:0}
  .hero-h{font-family:var(--S);font-size:clamp(4rem,7.5vw,7rem);line-height:.95;color:var(--ink);letter-spacing:-.02em;animation:fU .7s .08s ease both}
  .hero-h em{font-style:italic;color:var(--red)}
  .hero-sub{font-size:.85rem;line-height:1.9;color:var(--ink3);max-width:360px;font-weight:400;animation:fU .7s .16s ease both}
  .hero-btns{display:flex;gap:.75rem;margin-top:2.5rem;flex-wrap:wrap;animation:fU .7s .22s ease both}
  .btn-fill{display:inline-flex;align-items:center;gap:8px;padding:.75rem 1.6rem;border-radius:2px;background:var(--ink);color:var(--paper);font-size:.78rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;border:none;font-family:var(--B);transition:all .2s}
  .btn-fill:hover{background:var(--red)}
  .btn-ghost{display:inline-flex;align-items:center;gap:8px;padding:.75rem 1.6rem;border-radius:2px;background:transparent;color:var(--ink);font-size:.78rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;border:1px solid var(--rule2);font-family:var(--B);transition:all .2s}
  .btn-ghost:hover{border-color:var(--ink);background:var(--paper2)}
  .hero-stats{display:flex;flex-direction:column;gap:2.5rem;animation:fU .7s .28s ease both}
  .hstat{border-top:1px solid var(--rule);padding-top:1.2rem}
  .hstat-n{font-family:var(--S);font-size:3.5rem;color:var(--ink);line-height:1;letter-spacing:-.02em}
  .hstat-l{font-size:.7rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-top:4px}
  .hero-tag{font-size:.73rem;color:var(--ink4);line-height:1.8;font-style:italic;font-family:var(--S);max-width:300px;margin-top:3rem;border-left:2px solid var(--rule2);padding-left:1.2rem}
  .ticker-bar{height:48px;border-top:1px solid var(--rule);background:var(--paper2);display:flex;align-items:center;overflow:hidden}
  .ticker-track{display:flex;white-space:nowrap;animation:ticker 32s linear infinite}
  .ticker-item{padding:0 2.5rem;font-size:.66rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--ink3);border-right:1px solid var(--rule);flex-shrink:0;display:flex;align-items:center;gap:8px}
  .t-sq{width:4px;height:4px;background:var(--red);flex-shrink:0}
  @keyframes ticker{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
  @keyframes fU{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}

  /* SECTIONS */
  .sec{padding:100px 5%}
  .sec-inner{max-width:1200px;margin:0 auto}
  .sec-label{font-size:.68rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--ink4);display:flex;align-items:center;gap:10px;margin-bottom:.75rem}
  .sec-label::before{content:'';width:20px;height:1px;background:var(--red);flex-shrink:0}
  .sec-h{font-family:var(--S);font-size:clamp(2.5rem,4.5vw,4rem);color:var(--ink);letter-spacing:-.02em;line-height:1.05;margin-bottom:1.25rem}
  .sec-h em{font-style:italic;color:var(--ink3)}
  .sec-p{font-size:.9rem;color:var(--ink3);line-height:1.9;font-weight:400}

  /* ABOUT */
  .about{background:var(--paper);border-top:1px solid var(--rule)}
  .about-grid{display:grid;grid-template-columns:1.1fr 1fr;gap:0;border:1px solid var(--rule)}
  .about-left{background:var(--ink);padding:4rem;position:relative;overflow:hidden;border-right:none}
  .about-left::after{content:'5+';position:absolute;bottom:-40px;right:-20px;font-family:var(--S);font-size:14rem;color:rgba(255,255,255,.04);line-height:1;pointer-events:none;user-select:none}
  .about-year{font-family:var(--S);font-size:5.5rem;color:#fff;line-height:1;letter-spacing:-.03em}
  .about-year span{font-size:2rem;color:rgba(255,255,255,.4);font-family:var(--B);font-weight:400;letter-spacing:0}
  .about-desc{font-size:.88rem;color:rgba(255,255,255,.55);line-height:1.9;margin-top:1.5rem;font-weight:300;max-width:380px}
  .tech-list{margin-top:2.5rem;display:flex;flex-wrap:wrap;gap:6px}
  .tech{padding:5px 12px;border:1px solid rgba(255,255,255,.12);font-size:.68rem;font-weight:600;letter-spacing:.06em;color:rgba(255,255,255,.5);text-transform:uppercase}
  .about-right{padding:4rem;display:flex;flex-direction:column;justify-content:space-between;background:var(--paper)}
  .about-feats{display:flex;flex-direction:column;gap:0;border-top:1px solid var(--rule)}
  .afeat{display:flex;align-items:flex-start;gap:1.25rem;padding:1.5rem 0;border-bottom:1px solid var(--rule);transition:padding-left .25s}
  .afeat:hover{padding-left:.5rem}
  .afeat-ic{width:38px;height:38px;border:1px solid var(--rule);display:flex;align-items:center;justify-content:center;color:var(--ink3);flex-shrink:0;transition:all .25s}
  .afeat:hover .afeat-ic{border-color:var(--red);color:var(--red)}
  .afeat-t{font-size:.88rem;font-weight:700;color:var(--ink);margin-bottom:3px}
  .afeat-d{font-size:.78rem;color:var(--ink3);line-height:1.7}

  /* SERVICES */
  .services{background:var(--paper2);border-top:1px solid var(--rule)}
  .svc-top{display:grid;grid-template-columns:1fr 1fr;gap:4rem;margin-bottom:4rem;align-items:end}
  .svc-grid{display:grid;grid-template-columns:repeat(3,1fr);border:1px solid var(--rule)}
  .svc-card{padding:2.5rem 2rem;border-right:1px solid var(--rule);border-bottom:1px solid var(--rule);position:relative;overflow:hidden;transition:background .2s;cursor:default}
  .svc-card:nth-child(3n){border-right:none}
  .svc-card:nth-child(n+4){border-bottom:none}
  .svc-card:hover{background:var(--paper3)}
  .svc-n{font-size:.65rem;font-weight:700;letter-spacing:.12em;color:var(--ink4);margin-bottom:2rem}
  .svc-ic{width:40px;height:40px;border:1px solid var(--rule);display:flex;align-items:center;justify-content:center;color:var(--ink3);margin-bottom:1.25rem;transition:all .25s}
  .svc-card:hover .svc-ic{border-color:var(--red);color:var(--red)}
  .svc-t{font-size:.96rem;font-weight:700;color:var(--ink);margin-bottom:.6rem;line-height:1.2}
  .svc-d{font-size:.8rem;color:var(--ink3);line-height:1.8}
  .svc-line{position:absolute;bottom:0;left:0;right:0;height:2px;background:var(--red);transform:scaleX(0);transform-origin:left;transition:transform .3s}
  .svc-card:hover .svc-line{transform:scaleX(1)}

  /* PROJECTS */
  .projects{background:var(--paper);border-top:1px solid var(--rule)}
  .proj-hdr{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:3.5rem;gap:2rem;flex-wrap:wrap}
  .proj-count{font-family:var(--S);font-size:5rem;color:var(--rule);letter-spacing:-.04em;line-height:1;align-self:flex-start}
  .proj-grid{display:flex;flex-direction:column;gap:0;border:1px solid var(--rule)}
  .proj-row{display:grid;grid-template-columns:80px 1fr 1fr auto;align-items:center;padding:1.75rem 2rem;border-bottom:1px solid var(--rule);gap:2rem;transition:background .2s;cursor:default;position:relative}
  .proj-row:last-child{border-bottom:none}
  .proj-row:hover{background:var(--paper2)}
  .proj-row.flag{grid-template-columns:80px 1fr 1fr auto;background:var(--ink)}
  .proj-idx{font-size:.65rem;font-weight:700;letter-spacing:.1em;color:var(--ink4)}
  .proj-row.flag .proj-idx{color:rgba(255,255,255,.3)}
  .proj-row.flag:hover{background:#222018}
  .proj-info{}
  .proj-name-row{font-family:var(--S);font-size:1.5rem;color:var(--ink);line-height:1;letter-spacing:-.01em}
  .proj-row.flag .proj-name-row{color:#fff}
  .proj-sub-row{font-size:.75rem;color:var(--ink3);margin-top:4px;font-weight:500}
  .proj-row.flag .proj-sub-row{color:rgba(255,255,255,.4)}
  .proj-desc-col{font-size:.8rem;color:var(--ink3);line-height:1.75}
  .proj-row.flag .proj-desc-col{color:rgba(255,255,255,.5)}
  .proj-tags-col{display:flex;flex-wrap:wrap;gap:4px}
  .p-tag{font-size:.62rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:3px 8px;border:1px solid var(--rule);color:var(--ink3)}
  .proj-row.flag .p-tag{border-color:rgba(255,255,255,.15);color:rgba(255,255,255,.4)}
  .proj-arr-col{width:36px;height:36px;border:1px solid var(--rule);display:flex;align-items:center;justify-content:center;color:var(--ink3);flex-shrink:0;transition:all .25s}
  .proj-row:hover .proj-arr-col{border-color:var(--red);color:var(--red);transform:rotate(45deg)}
  .proj-row.flag .proj-arr-col{border-color:rgba(255,255,255,.15);color:rgba(255,255,255,.3)}
  .proj-row.flag:hover .proj-arr-col{border-color:var(--red);color:var(--red)}
  .flag-pill{display:inline-flex;align-items:center;gap:6px;font-size:.62rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;background:var(--red);color:#fff;padding:3px 10px;margin-bottom:6px}
  .flag-stats{display:flex;gap:2rem;margin-top:.75rem}
  .fs-n{font-family:var(--S);font-size:1.6rem;color:#fff;line-height:1}
  .fs-l{font-size:.62rem;color:rgba(255,255,255,.35);letter-spacing:.06em;text-transform:uppercase;margin-top:2px}

  /* AI / INNOVATION */
  .ai-sec{background:var(--paper2);border-top:1px solid var(--rule)}
  .ai-grid{display:grid;grid-template-columns:1fr 1fr;gap:0;border:1px solid var(--rule)}
  .ai-left{padding:4rem;border-right:1px solid var(--rule)}
  .ai-right{padding:4rem;background:var(--ink);position:relative;overflow:hidden}
  .ai-right::before{content:'AI';position:absolute;bottom:-60px;right:-40px;font-family:var(--S);font-size:18rem;color:rgba(255,255,255,.03);line-height:1;pointer-events:none}
  .ai-right .sec-h{color:#fff}
  .ai-right .sec-p{color:rgba(255,255,255,.45)}
  .ai-right .sec-label{color:rgba(255,255,255,.3)}
  .ai-right .sec-label::before{background:var(--red)}
  .ai-visual-card{background:#fff;border:1px solid var(--rule);padding:2rem;margin-top:2.5rem}
  .avc-label{font-size:.65rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--ink4);margin-bottom:.5rem}
  .avc-val{font-family:var(--S);font-size:2.8rem;color:var(--ink);line-height:1;letter-spacing:-.02em}
  .avc-sub{font-size:.75rem;color:var(--ink3);margin-top:4px}
  .live-badge{display:inline-flex;align-items:center;gap:6px;font-size:.65rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;background:var(--red-pale);color:var(--red);padding:4px 10px;margin-bottom:1.5rem}
  .live-dot{width:5px;height:5px;border-radius:50%;background:var(--red);animation:blink 1.4s infinite}
  @keyframes blink{0%,100%{opacity:1}50%{opacity:.2}}
  .ai-feats{display:flex;flex-direction:column;gap:0;margin-top:2.5rem;border-top:1px solid rgba(255,255,255,.08)}
  .ai-feat{display:flex;align-items:flex-start;gap:1.25rem;padding:1.25rem 0;border-bottom:1px solid rgba(255,255,255,.08)}
  .ai-feat-ic{width:36px;height:36px;border:1px solid rgba(255,255,255,.1);display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.35);flex-shrink:0}
  .ai-feat-t{font-size:.86rem;font-weight:700;color:#fff;margin-bottom:3px}
  .ai-feat-d{font-size:.77rem;color:rgba(255,255,255,.4);line-height:1.7}

  /* WHY */
  .why{background:var(--paper);border-top:1px solid var(--rule)}
  .why-hdr{display:grid;grid-template-columns:1fr 2fr;gap:4rem;margin-bottom:4rem;align-items:end}
  .why-grid{display:grid;grid-template-columns:repeat(5,1fr);border:1px solid var(--rule)}
  .why-card{padding:2.5rem 1.75rem;border-right:1px solid var(--rule);transition:background .2s}
  .why-card:last-child{border-right:none}
  .why-card:hover{background:var(--paper2)}
  .why-n{font-family:var(--S);font-size:3rem;color:var(--ink);line-height:1;letter-spacing:-.02em;margin-bottom:.5rem}
  .why-l{font-size:.75rem;font-weight:700;color:var(--ink);letter-spacing:.04em;margin-bottom:.4rem}
  .why-d{font-size:.73rem;color:var(--ink4);line-height:1.6}
  .why-ic{color:var(--red);margin-bottom:1rem}

  /* TESTIMONIALS */
  .testi{background:var(--paper2);border-top:1px solid var(--rule)}
  .testi-hdr{margin-bottom:3.5rem}
  .testi-grid{display:grid;grid-template-columns:repeat(3,1fr);border:1px solid var(--rule)}
  .testi-card{padding:2.5rem;border-right:1px solid var(--rule);transition:background .2s}
  .testi-card:last-child{border-right:none}
  .testi-card:hover{background:var(--paper3)}
  .t-q{color:var(--red);opacity:.3;margin-bottom:.75rem}
  .stars{color:var(--ink);font-size:.78rem;letter-spacing:3px;margin-bottom:1rem;opacity:.4}
  .t-txt{font-family:var(--S);font-size:.96rem;color:var(--ink2);line-height:1.85;font-style:italic;margin-bottom:1.5rem}
  .t-auth{display:flex;align-items:center;gap:12px;padding-top:1.25rem;border-top:1px solid var(--rule)}
  .t-av{width:38px;height:38px;background:var(--ink);display:flex;align-items:center;justify-content:center;font-family:var(--S);font-size:1rem;color:#fff;font-style:italic;flex-shrink:0}
  .t-name{font-size:.84rem;font-weight:700;color:var(--ink)}
  .t-co{font-size:.7rem;color:var(--ink4)}

  /* CONTACT */
  .contact{background:var(--paper);border-top:1px solid var(--rule)}
  .contact-grid{display:grid;grid-template-columns:1fr 1fr;gap:0;border:1px solid var(--rule)}
  .contact-left{padding:4rem;border-right:1px solid var(--rule)}
  .contact-right{padding:4rem;background:var(--paper2)}
  .c-items{margin-top:2.5rem;display:flex;flex-direction:column;gap:0;border-top:1px solid var(--rule)}
  .ci{display:flex;align-items:center;gap:1.25rem;padding:1.25rem 0;border-bottom:1px solid var(--rule);transition:padding-left .2s}
  .ci:hover{padding-left:.5rem}
  .ci-ic{width:38px;height:38px;border:1px solid var(--rule);display:flex;align-items:center;justify-content:center;color:var(--ink3);flex-shrink:0;transition:all .2s}
  .ci:hover .ci-ic{border-color:var(--red);color:var(--red)}
  .ci-l{font-size:.65rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--ink4)}
  .ci-v{font-size:.88rem;font-weight:600;color:var(--ink);margin-top:2px}
  .f-h{font-family:var(--S);font-size:2rem;color:var(--ink);letter-spacing:-.01em;margin-bottom:.4rem}
  .f-sub{font-size:.8rem;color:var(--ink3);margin-bottom:2rem}
  .f-l{display:block;font-size:.65rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:8px}
  .f-i,.f-ta{width:100%;background:var(--paper);border:1px solid var(--rule);border-radius:0;padding:.85rem 1rem;color:var(--ink);font-family:var(--B);font-size:.88rem;outline:none;resize:none;transition:border-color .2s;margin-bottom:1rem;display:block}
  .f-i:focus,.f-ta:focus{border-color:var(--ink)}
  .f-i::placeholder,.f-ta::placeholder{color:var(--ink4)}
  .f-btn{width:100%;padding:.9rem;border:none;border-radius:0;background:var(--ink);color:var(--paper);font-weight:700;font-family:var(--B);font-size:.82rem;cursor:pointer;transition:background .2s;letter-spacing:.08em;text-transform:uppercase}
  .f-btn:hover{background:var(--red)}
  .sent-wrap{text-align:center;padding:3rem 1rem}
  .sent-ic{color:var(--red);margin-bottom:1rem;display:flex;justify-content:center}
  .sent-t{font-family:var(--S);font-size:1.8rem;font-style:italic;color:var(--ink);margin-bottom:.5rem}
  .sent-s{color:var(--ink3);font-size:.85rem}

  /* FOOTER */
  footer{background:var(--ink);border-top:1px solid rgba(255,255,255,.06);padding:0 5%}
  .foot-top{display:grid;grid-template-columns:1fr 1fr 1fr;border-bottom:1px solid rgba(255,255,255,.08);padding:3rem 0}
  .foot-brand{}
  .foot-logo{font-family:var(--S);font-size:2rem;font-style:italic;color:#fff;letter-spacing:-.01em}
  .foot-tag{font-size:.72rem;color:rgba(255,255,255,.3);margin-top:6px;font-weight:400}
  .foot-col-h{font-size:.65rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.25);margin-bottom:1.25rem}
  .foot-links{display:flex;flex-direction:column;gap:.5rem}
  .foot-links a{color:rgba(255,255,255,.45);font-size:.82rem;font-weight:500;transition:color .2s}
  .foot-links a:hover{color:#fff}
  .foot-bot{display:flex;align-items:center;justify-content:space-between;padding:1.5rem 0;flex-wrap:wrap;gap:1rem}
  .copy{font-size:.7rem;color:rgba(255,255,255,.2)}

  .reveal{opacity:0;transform:translateY(20px);transition:opacity .6s ease,transform .6s ease}
  .reveal.vis{opacity:1;transform:translateY(0)}

  @media(max-width:1024px){
    .hero-body{grid-template-columns:1fr}
    .hero-right{border-top:1px solid var(--rule);padding:3rem 5%}
    .about-grid,.contact-grid,.ai-grid{grid-template-columns:1fr}
    .about-left,.contact-left,.ai-left,.ai-right{border-right:none;border-bottom:1px solid var(--rule)}
    .svc-grid{grid-template-columns:repeat(2,1fr)}
    .svc-card:nth-child(3n){border-right:1px solid var(--rule)}
    .svc-card:nth-child(2n){border-right:none}
    .why-grid{grid-template-columns:repeat(3,1fr)}
    .testi-grid{grid-template-columns:1fr}
    .testi-card{border-right:none;border-bottom:1px solid var(--rule)}
    .testi-card:last-child{border-bottom:none}
    .proj-row{grid-template-columns:60px 1fr auto}
    .proj-desc-col{display:none}
    .why-hdr{grid-template-columns:1fr}
    .foot-top{grid-template-columns:1fr 1fr}
    .svc-top{grid-template-columns:1fr}
  }
  @media(max-width:768px){
    .nav-links{display:none}
    .svc-grid{grid-template-columns:1fr}
    .svc-card{border-right:none}
    .svc-card:nth-child(3n){border-right:none}
    .why-grid{grid-template-columns:repeat(2,1fr)}
    .why-card:nth-child(2n){border-right:none}
    .proj-row{grid-template-columns:1fr auto;padding:1.25rem}
    .proj-idx{display:none}
    .proj-tags-col{display:none}
    .foot-top{grid-template-columns:1fr}
    .hero-h{font-size:3.2rem}
  }
`;

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("vis"); io.unobserve(e.target); } }), { threshold: 0.08 });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function Nav() {
  const [on, setOn] = useState(false);
  useEffect(() => { const h = () => setOn(window.scrollY > 20); window.addEventListener("scroll", h); return () => window.removeEventListener("scroll", h); }, []);
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <nav className={`nav${on ? " on" : ""}`}>
      <div className="logo"><b>Hypervolar</b></div>
      <ul className="nav-links">
        {["about","services","projects","innovation","contact"].map(id => (
          <li key={id}><a href={`#${id}`} onClick={e => { e.preventDefault(); go(id); }}>{id}</a></li>
        ))}
      </ul>
      <button className="nav-cta" onClick={() => go("contact")}>Let's Talk <IC.ArrowR /></button>
    </nav>
  );
}

const TICKS = ["Custom Software","Healthcare Systems","AI Vision","ERP Automation","Node.js · React","Power BI","ML Pipelines","5+ Years","20+ Projects","10+ Clients"];

function Hero() {
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const items = [...TICKS, ...TICKS];
  const cols = [10, 22, 35, 52, 66, 80];
  return (
    <section id="hero" className="hero">
      <div className="hero-lines" aria-hidden="true">
        {cols.map(l => <div className="hero-col" key={l} style={{ left: l + "%" }} />)}
      </div>
      <div className="hero-body">
        <div className="hero-left">
          <div>
            <div className="eyebrow"><span className="ey-dot" />Engineering Studio — Est. 2019</div>
            <h1 className="hero-h">
              Turning<br />
              Your Vision<br />
              Into <em>Reality.</em>
            </h1>
          </div>
          <div>
            <p className="hero-sub">5+ years building smart solutions across Healthcare, ERP, AI & Automation. Complex challenges transformed into scalable systems.</p>
            <div className="hero-btns">
              <button className="btn-fill" onClick={() => go("projects")}>View Our Work <IC.Arrow /></button>
              <button className="btn-ghost" onClick={() => go("contact")}>Start a Project</button>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-stats">
            {[["5+", "Years Experience"], ["20+", "Systems Delivered"], ["10+", "Clients Served"]].map(([n, l]) => (
              <div className="hstat" key={l}>
                <div className="hstat-n">{n}</div>
                <div className="hstat-l">{l}</div>
              </div>
            ))}
          </div>
          <p className="hero-tag">"Every complex problem has an elegant engineering solution. We've proven it — again and again."</p>
        </div>
      </div>
      <div className="ticker-bar">
        <div className="ticker-track">
          {items.map((t, i) => <div className="ticker-item" key={i}><span className="t-sq" />{t}</div>)}
        </div>
      </div>
    </section>
  );
}

const AFEATS = [
  { Icon: IC.Pulse, t: "Scalable Architecture", d: "Built for the next 5 years, not just the next sprint." },
  { Icon: IC.CPU, t: "AI-First Engineering", d: "Intelligence baked into every layer — not bolted on after." },
  { Icon: IC.Shield, t: "Long-Term Partnership", d: "We don't ship and disappear. We stay and grow with you." },
];

function About() {
  return (
    <section id="about" className="sec about">
      <div className="sec-inner">
        <div className="sec-label reveal">Our Story</div>
        <div className="about-grid reveal">
          <div className="about-left">
            <div className="about-year">5<span> years</span></div>
            <p className="about-desc">A team of expert engineers, AI specialists, and system architects who thrive where complexity is highest. Building production-grade software across healthcare, enterprise, logistics, and AI since 2019.</p>
            <div className="tech-list">
              {["Node.js","React","Python","AI / ML","Computer Vision","Power BI","Automation","PostgreSQL","Oracle","Laravel","Docker"].map(t => <span className="tech" key={t}>{t}</span>)}
            </div>
          </div>
          <div className="about-right">
            <div>
              <h2 className="sec-h">Built to Solve.<br /><em>Made to Scale.</em></h2>
              <p className="sec-p">We started with a single belief: every complex problem has an elegant engineering solution. Across healthcare, enterprise, logistics, and AI — we've proven it again and again.</p>
            </div>
            <div className="about-feats">
              {AFEATS.map(f => (
                <div className="afeat" key={f.t}>
                  <div className="afeat-ic"><f.Icon /></div>
                  <div><div className="afeat-t">{f.t}</div><div className="afeat-d">{f.d}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const SVCS = [
  { n: "01", Icon: IC.Code, t: "Custom Software Development", d: "Tailor-made platforms engineered for your exact business logic. Clean architecture, scalable codebases, zero shortcuts." },
  { n: "02", Icon: IC.Health, t: "Healthcare Systems", d: "HMS, IVF clinic management, CRM platforms — purpose-built for high-stakes healthcare workflows and regulatory requirements." },
  { n: "03", Icon: IC.Grid, t: "ERP & Business Automation", d: "Unified ERP systems connecting procurement, inventory, finance, and HR — eliminating silos and manual overhead entirely." },
  { n: "04", Icon: IC.Brain, t: "AI / ML & Vision Systems", d: "Custom models, computer vision pipelines, and ML-powered automation. We built a live yard-tracking AI for CONCOR." },
  { n: "05", Icon: IC.Chart, t: "Dashboard & Analytics", d: "Power BI dashboards and custom reporting pipelines that surface real insights from complex operational data." },
  { n: "06", Icon: IC.Globe, t: "Web Development & Support", d: "High-performance web applications with long-term technical support. We evolve your digital presence as you grow." },
];

function Services() {
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" className="sec services">
      <div className="sec-inner">
        <div className="svc-top reveal">
          <div>
            <div className="sec-label">What We Do</div>
            <h2 className="sec-h">End-to-End<br /><em>Engineering</em></h2>
          </div>
          <div>
            <p className="sec-p">From idea to production across every domain — we handle the full lifecycle of complex software.</p>
            <button className="btn-fill" style={{ marginTop: "1.75rem" }} onClick={() => go("contact")}>Start a Project <IC.ArrowR /></button>
          </div>
        </div>
        <div className="svc-grid reveal">
          {SVCS.map((s, i) => (
            <div className="svc-card" key={s.t}>
              <div className="svc-n">{s.n}</div>
              <div className="svc-ic"><s.Icon /></div>
              <div className="svc-t">{s.t}</div>
              <p className="svc-d">{s.d}</p>
              <div className="svc-line" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const PROJS = [
  { id: "01", cat: "Healthcare", Icon: IC.IVF, name: "Aveya IVF", sub: "IVF Clinic Management System", desc: "End-to-end IVF workflow covering patient intake, cycle tracking, embryology lab, billing, and reporting.", tags: ["HMS", "CRM", "Web App"] },
  { id: "02", cat: "Healthcare", Icon: IC.HMS, name: "Lifelinkr", sub: "Hospital Management System", desc: "Multi-department HMS covering OPD, IPD, pharmacy, lab, radiology, and finance in a single platform.", tags: ["HMS", "Automation"] },
  { id: "03", cat: "HR & Management", Icon: IC.HR, name: "Traveme", sub: "HR & Employee Management", desc: "Full-cycle HR platform — attendance, payroll, leave, performance tracking, and hiring pipeline.", tags: ["ERP", "Automation"] },
  { id: "04", cat: "Enterprise", Icon: IC.ERP, name: "Ananta Group", sub: "Enterprise Resource Planning", desc: "Custom group-level ERP managing procurement, manufacturing, distribution, and finance across units.", tags: ["ERP", "Enterprise"] },
  { id: "05", cat: "Healthcare + Web", Icon: IC.Web, name: "SCI Hospital", sub: "Website & Technical Support", desc: "Professional website development and long-term technical support — design, performance, SEO.", tags: ["Web", "Healthcare"] },
  { id: "06", cat: "CRM", Icon: IC.CRM, name: "Vatsalya", sub: "CRM & Client Management", desc: "Smart CRM with lead tracking, customer lifecycle, follow-up automation, and reporting dashboards.", tags: ["CRM", "Automation"] },
];

function Projects() {
  return (
    <section id="projects" className="sec projects">
      <div className="sec-inner">
        <div className="proj-hdr reveal">
          <div>
            <div className="sec-label">Our Work</div>
            <h2 className="sec-h">Work That<br /><em>Speaks for Itself.</em></h2>
          </div>
          <div className="proj-count">07</div>
        </div>
        <div className="proj-grid reveal">
          {/* CONCOR flagship */}
          <div className="proj-row flag">
            <div className="proj-idx">07</div>
            <div className="proj-info">
              <div className="flag-pill"><span className="live-dot" />AI Vision · Flagship</div>
              <div className="proj-name-row">CONCOR</div>
              <div className="proj-sub-row">AI-Based Yard Automation — Vision System</div>
              <div className="flag-stats">
                {[["90%","Error Reduction"],["Real-Time","Live Tracking"],["Custom ML","Models Built"]].map(([n,l]) => (
                  <div key={l}><div className="fs-n">{n}</div><div className="fs-l">{l}</div></div>
                ))}
              </div>
            </div>
            <div className="proj-desc-col" style={{ color: "rgba(255,255,255,.45)", maxWidth: 320 }}>Real-time computer vision platform for autonomous container and vehicle tracking. Integrates live camera feeds, OCR, and custom ML models at one of India's largest logistics companies.</div>
            <div className="proj-tags-col">
              {["AI","Vision","ML","Logistics"].map((t, i) => <span className="p-tag" key={i}>{t}</span>)}
            </div>
            <div className="proj-arr-col"><IC.Arrow /></div>
          </div>
          {/* regular rows */}
          {PROJS.map((p, i) => (
            <div className="proj-row" key={p.name}>
              <div className="proj-idx">{p.id}</div>
              <div className="proj-info">
                <div className="proj-name-row">{p.name}</div>
                <div className="proj-sub-row">{p.cat} — {p.sub}</div>
              </div>
              <div className="proj-desc-col">{p.desc}</div>
              <div className="proj-tags-col">{p.tags.map((t, j) => <span className="p-tag" key={j}>{t}</span>)}</div>
              <div className="proj-arr-col"><IC.Arrow /></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const AIFEATS = [
  { Icon: IC.Eye, t: "Vision AI for Yard & Container Tracking", d: "Live camera-based recognition and tracking of containers, vehicles, and assets. Deployed at CONCOR." },
  { Icon: IC.Zap, t: "Intelligent Process Automation", d: "ML-driven workflows eliminating manual bottlenecks — from document processing to predictive routing." },
  { Icon: IC.Monitor, t: "Real-Time Monitoring Systems", d: "Live dashboards and alert systems that surface critical events the moment they happen." },
  { Icon: IC.Brain, t: "Custom ML Model Development", d: "Purpose-built models trained on your domain data — classification, object detection, NLP, and predictive analytics." },
];

function Innovation() {
  return (
    <section id="innovation" className="sec ai-sec">
      <div className="sec-inner">
        <div className="ai-grid reveal">
          <div className="ai-left">
            <div className="sec-label">AI & Innovation</div>
            <h2 className="sec-h">Intelligence<br /><em>Built In.</em></h2>
            <p className="sec-p">We don't bolt AI on as an afterthought. We architect intelligent systems from the ground up — with computer vision, ML pipelines, and real-time automation at the core.</p>
            <div className="ai-visual-card">
              <div className="avc-label">CONCOR Yard AI — Live Metric</div>
              <div className="avc-val">90%</div>
              <div className="avc-sub">Reduction in manual tracking errors · Real-time, autonomous</div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1px", marginTop: "1px", background: "var(--rule)" }}>
              {[["&lt;1s","Detection Speed"],["24/7","System Uptime"]].map(([n, l]) => (
                <div key={l} style={{ background: "var(--paper2)", padding: "1.25rem 1rem" }}>
                  <div className="avc-label">{l}</div>
                  <div style={{ fontFamily: "var(--S)", fontSize: "1.8rem", color: "var(--ink)", letterSpacing: "-.02em" }} dangerouslySetInnerHTML={{ __html: n }} />
                </div>
              ))}
            </div>
          </div>
          <div className="ai-right">
            <div className="live-badge"><span className="live-dot" />Live at CONCOR · India</div>
            <h2 className="sec-h" style={{ color: "#fff" }}>Vision AI<br /><em style={{ color: "rgba(255,255,255,.5)" }}>Yard Tracking</em></h2>
            <p className="sec-p" style={{ color: "rgba(255,255,255,.4)", marginTop: ".5rem" }}>We don't build demos. We build systems that run at industrial scale — every day, in production.</p>
            <div className="ai-feats">
              {AIFEATS.map(f => (
                <div className="ai-feat" key={f.t}>
                  <div className="ai-feat-ic"><f.Icon /></div>
                  <div><div className="ai-feat-t">{f.t}</div><div className="ai-feat-d">{f.d}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const WHY = [
  { Icon: IC.Award, n: "5+", l: "Years Experience", d: "Proven across healthcare, enterprise, logistics, and AI." },
  { Icon: IC.Layers, n: "20+", l: "Systems Delivered", d: "Production systems at real companies, at scale." },
  { Icon: IC.Sparkle, n: "AI", l: "First Mindset", d: "Intelligence evaluated in every engagement." },
  { Icon: IC.Infinite, n: "∞", l: "Scalable Architecture", d: "We build for 5 years. Zero technical debt." },
  { Icon: IC.Users, n: "24/7", l: "Reliable Support", d: "Long-term partnership, not one-time delivery." },
];
const Award   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>;
const Layers  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
const Sparkle = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z"/></svg>;
const Infinite= () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 12c-2-2.5-4-4-6-4a4 4 0 0 0 0 8c2 0 4-1.5 6-4z"/><path d="M12 12c2 2.5 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.5-6 4z"/></svg>;
const UsersI  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const WHY_ICONS = [Award, Layers, Sparkle, Infinite, UsersI];

function Why() {
  return (
    <section className="sec why">
      <div className="sec-inner">
        <div className="why-hdr reveal">
          <div>
            <div className="sec-label">Why Us</div>
            <h2 className="sec-h">Why Teams<br /><em>Trust Us</em></h2>
          </div>
          <p className="sec-p" style={{ maxWidth: 420, alignSelf: "end" }}>We bring more than code — commitment, expertise, and a problem-solving DNA that runs through everything we build.</p>
        </div>
        <div className="why-grid reveal">
          {WHY.map((w, i) => {
            const WIcon = WHY_ICONS[i];
            return (
              <div className="why-card" key={w.l}>
                <div className="why-ic"><WIcon /></div>
                <div className="why-n">{w.n}</div>
                <div className="why-l">{w.l}</div>
                <div className="why-d">{w.d}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

const TESTIS = [
  { av: "A", name: "Ajay Pandey", co: "Team, TravMe", text: "Hypervolar built a complete HR and management system for us that streamlined operations and improved team productivity. Their understanding of real business needs is impressive." },
  { av: "S", name: "Sukhwant Gandhi", co: "Director, Aveya IVF", text: "The IVF management system developed by Hypervolar transformed our clinic operations. From patient tracking to reporting, everything is now efficient and reliable." },
  { av: "B", name: "Bharat Singh", co: "Founder, 360Plot", text: "Their ability to understand complex requirements and convert them into scalable software is outstanding. The platform they delivered is fast, reliable, and future-ready." },
];

function Testimonials() {
  return (
    <section className="sec testi">
      <div className="sec-inner">
        <div className="testi-hdr reveal">
          <div className="sec-label">Client Voices</div>
          <h2 className="sec-h">What Clients <em>Say</em></h2>
        </div>
        <div className="testi-grid reveal">
          {TESTIS.map((t, i) => (
            <div className="testi-card" key={t.name}>
              <div className="t-q"><IC.Quote /></div>
              <div className="stars">★★★★★</div>
              <p className="t-txt">"{t.text}"</p>
              <div className="t-auth">
                <div className="t-av">{t.av}</div>
                <div><div className="t-name">{t.name}</div><div className="t-co">{t.co}</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const CITEMS = [
  { Icon: IC.Mail, l: "Email", v: "hypervolar@gmail.com", link: "mailto:hypervolar@gmail.com" },
  { Icon: IC.Phone, l: "Phone", v: "+91 78274 36219", link: "tel:+917827436219" },
  { Icon: IC.MapPin, l: "Location", v: "India · Remote-First" },
];

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSend = async e => {
    e.preventDefault(); setLoading(true);
    try {
      const res = await fetch("https://sahilkkc01.app.n8n.cloud/webhook-test/e744f1c7-e4ca-400f-bd6a-05da19147f0a", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form),
      });
      if (res.ok) { setSent(true); setForm({ name: "", email: "", message: "" }); }
      else alert("Something went wrong");
    } catch { alert("Server error"); }
    setLoading(false);
  };
  return (
    <section id="contact" className="sec contact">
      <div className="sec-inner">
        <div className="sec-label reveal">Get In Touch</div>
        <div className="contact-grid reveal">
          <div className="contact-left">
            <h2 className="sec-h">Let's Build<br /><em>Together.</em></h2>
            <p className="sec-p" style={{ marginTop: "1rem" }}>Have a complex challenge, a system to build, or just an idea? Every great solution starts with a conversation.</p>
            <div className="c-items">
              {CITEMS.map(c => (
                <div className="ci" key={c.l}>
                  <div className="ci-ic"><c.Icon /></div>
                  <div>
                    <div className="ci-l">{c.l}</div>
                    <div className="ci-v">{c.link ? <a href={c.link}>{c.v}</a> : c.v}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="contact-right">
            {!sent ? (
              <>
                <div className="f-h">Start a Conversation</div>
                <p className="f-sub">Tell us about your project. We respond within 24 hours.</p>
                <form onSubmit={handleSend}>
                  <label className="f-l">Name</label>
                  <input className="f-i" name="name" value={form.name} onChange={handleChange} placeholder="Your name" required />
                  <label className="f-l">Email</label>
                  <input className="f-i" name="email" value={form.email} onChange={handleChange} placeholder="Your email" required />
                  <label className="f-l">Message</label>
                  <textarea className="f-ta" name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your project" rows={4} required />
                  <button className="f-btn" type="submit">{loading ? "Sending..." : "Send Message →"}</button>
                </form>
              </>
            ) : (
              <div className="sent-wrap">
                <div className="sent-ic"><IC.Check /></div>
                <div className="sent-t">Message Sent.</div>
                <p className="sent-s">We'll be in touch within 24 hours.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer>
      <div className="foot-top">
        <div className="foot-brand">
          <div className="foot-logo">Hypervolar</div>
          <div className="foot-tag">Engineering Solutions That Matter</div>
        </div>
        <div>
          <div className="foot-col-h">Navigation</div>
          <div className="foot-links">
            {["about","services","projects","innovation","contact"].map(id => (
              <a href={`#${id}`} key={id} onClick={e => { e.preventDefault(); go(id); }}>{id[0].toUpperCase() + id.slice(1)}</a>
            ))}
          </div>
        </div>
        <div>
          <div className="foot-col-h">Contact</div>
          <div className="foot-links">
            <a href="mailto:hypervolar@gmail.com">hypervolar@gmail.com</a>
            <a href="tel:+917827436219">+91 78274 36219</a>
            <span style={{ color: "rgba(255,255,255,.35)", fontSize: ".82rem" }}>India · Remote-First</span>
          </div>
        </div>
      </div>
      <div className="foot-bot">
        <span className="copy">© {new Date().getFullYear()} Hypervolar. All rights reserved.</span>
        <span className="copy">Crafted with precision, engineered with purpose.</span>
      </div>
    </footer>
  );
}

export default function HypervolarAuthentic() {
  useReveal();
  return (
    <>
      <style>{CSS}</style>
      <FontLink />
      <Nav />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Innovation />
      <Why />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
}